export default "__VITE_ASSET__f42dca95__"